import { render, staticRenderFns } from "./LandingOnboardingIntoAdIntake.vue?vue&type=template&id=39caeaf0&scoped=true"
import script from "./LandingOnboardingIntoAdIntake.vue?vue&type=script&lang=js"
export * from "./LandingOnboardingIntoAdIntake.vue?vue&type=script&lang=js"
import style0 from "./LandingOnboardingIntoAdIntake.vue?vue&type=style&index=0&id=39caeaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39caeaf0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingOnboardingNl: require('/src/components/landing/LandingOnboardingNl.vue').default})
